import {
  Component,
  OnInit,
  AfterViewInit,
  AfterContentInit,
  AfterContentChecked,
  OnDestroy
} from '@angular/core';
import {DataStorageService} from './../../../data-storage.service';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';
import {ApiOfferService} from '../../../apiServices/offer/api-offer.service';
import {b} from '@angular/core/src/render3';

enum Checkboxes {
  peoplephoneSIPTRUNK = 0,
  peoplephoneHosted,
  datasim,
  mobile,
  bundle,
  threeCX,
  microsoftTeams,
  OperatorConnect,
  SBCplus,
  PeoplefoneMittel,
  newPhoneNumbers,
  phoneNumbersToBePorted,
  FlatRateSIPTRUNK,
  FlatRateHOSTED,
  IPworldcom,
  cyberlink,
  peoplephoneDevicesDataBase,
  myDevicesDataBase,
  ENUM_LENGTH

}

@Component({
  selector: 'app-select-solution',
  templateUrl: './select-solution.component.html',
  styleUrls: ['./select-solution.component.scss']
})
export class SelectSolutionComponent implements OnInit, AfterViewInit, AfterContentInit, AfterContentChecked, OnDestroy {

  allowModifications: boolean;

  constructor(public dataStorageService: DataStorageService,
              private oApi: ApiOfferService) {
      this.dataStorageService.currentComponent = 1;
  }

  ngOnInit() {
    this.dataStorageService.currentComponent = AvailableComponents['WishedSolution'];
    const element = document.getElementById('selectWished');
    element.classList.add('active');
    this.allowModifications = this.dataStorageService.currentState.offerID === 0;
  }

  ngOnDestroy() {
    const element = document.getElementById('selectWished');
    element.classList.remove('active');
  }

  ngAfterViewInit() {
    for (let i = 0; i <= Checkboxes.ENUM_LENGTH; i++) {
      const checkbox = <HTMLInputElement> document.getElementById(Checkboxes[i]);
      //debugger
      if(checkbox)
        checkbox.checked = this.dataStorageService.currentState.wishedSolution[AvailableComponents[i + 2]];
    }
  }
  ngAfterContentInit() {
    this.dataStorageService.currentComponent = AvailableComponents.WishedSolution;
  }

  ngAfterContentChecked() {
    this.dataStorageService.currentComponent = AvailableComponents.WishedSolution;
  }

  onSelectClick(e: any) {
    const checkbox = <HTMLInputElement>document.getElementById(e.target.id);

    switch (e.target.id) {
      case 'IPworldcom': {
        this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetIPworldcom = checkbox.checked;
        break;
      }
      case 'cyberlink': {
        this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetCyberlink = checkbox.checked;
        break;
      }
      case 'phoneNumbersToBePorted': {
        this.dataStorageService.currentState.wishedSolution.PhoneNumbersToBePorted = checkbox.checked;
        break;
      }
      case 'newPhoneNumbers': {
        this.dataStorageService.currentState.wishedSolution.NewPhoneNumbers = checkbox.checked;
        break;
      }
      case 'peoplephoneSIPTRUNK': {
        this.dataStorageService.currentState.wishedSolution.PeoplephoneSIPTRUNK = checkbox.checked;
        break;
      }
      case 'peoplephoneHosted': {
        this.dataStorageService.currentState.wishedSolution.PeoplephoneHosted = checkbox.checked;
        break;
      }
      case 'threeCX': {
        this.dataStorageService.currentState.wishedSolution.ThreeCX = checkbox.checked;
        break;
      }
      case 'microsoftTeams': {
        this.dataStorageService.currentState.wishedSolution.MicrosoftTeams = checkbox.checked;
        break;
      }
      case 'OperatorConnect': {
        this.dataStorageService.currentState.wishedSolution.OperatorConnect = checkbox.checked;
        break;
      }
      case 'SBCplus': {
        this.dataStorageService.currentState.wishedSolution.SBCplus = checkbox.checked;
        break;
      }
      case 'bundle': {
        this.dataStorageService.currentState.wishedSolution.PeoplefoneBundle = checkbox.checked;
        break;
      }
      case 'FlatRateHOSTED': {
        this.dataStorageService.currentState.wishedSolution.FlatRateHOSTED = checkbox.checked;
        if (checkbox.checked) {
          this.dataStorageService.currentState.businessFlatRateHosted.chosenType = this.dataStorageService.flatRateHostedPricing[0].networkType;
        }
        break;
      }
      case 'FlatRateSIPTRUNK': {
        this.dataStorageService.currentState.wishedSolution.FlatRateSIPTRUNK = checkbox.checked;
        if (checkbox.checked) {
          this.dataStorageService.currentState.businessFlatRateSipTrunk.chosenType = this.dataStorageService.flatRateSipTrunkPricing[0].networkType;
        }
        break;
      }
      case 'peoplephoneDevicesDataBase': {
        this.dataStorageService.currentState.wishedSolution.PeoplephoneDevicesDataBase = checkbox.checked;
        break;
      }
      case 'myDevicesDataBase': {
        this.dataStorageService.currentState.wishedSolution.MyDevicesDataBase = checkbox.checked;
        break;
      }
      case 'PeoplefoneMittel': {
        this.dataStorageService.currentState.wishedSolution.PeoplefoneMittel = checkbox.checked;
        break;
      }
      case 'datasim' : {
        this.dataStorageService.currentState.wishedSolution.Datasim = checkbox.checked;
        break;
      }
      case 'mobile' : {
        this.dataStorageService.currentState.wishedSolution.mobile = checkbox.checked;
        break;
      }
      default: {
        break;
      }
    }

    this.saveSolution();
  }

  saveSolution() {
    this.oApi.putOfferOptions();
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/select-solution/select-solution.component.ts